import { ReactComponent as ConsumerGoodsSVG } from '../../../assets/images/icons/product_icons/product_recall_cg_icon.svg';

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const ProductRecallCGIcon = (props: any) => {
    return (
        <SvgIcon {...props} component={ConsumerGoodsSVG} inheritViewBox />
        // <SvgIcon {...props}>
        //     <ConsumerGoodsSVG />
        // </SvgIcon>
    );
};

export default ProductRecallCGIcon;